module.exports = __webpack_public_path__ + "img/user_WangHailin.b51b5c96.png";